import React from 'react'
import ReactDOM from 'react-dom'
import TouchButton from '../../utils/ope-touch-button'
import ImageContainer from './cropper-image-container'
import ImageStore from '../../../stores/image-store'
import touchHandler from './touch-handlers'
import CropperRotate from './cropper-rotate'
import CropperZoom from './cropper-zoom'
import EditorActions from '../../../actions/editor-actions'
import SelectorActions from '../../../actions/selector-actions'
import createReactClass from 'create-react-class'


// XE-14037 we need to filter certain characters as the editor gateway does not
// have all unicode characters available

var ALLOWED_LATIN_CHARACTERS = /[^\u0020-\u007E\u00A0-\u00A3\u00A5\u00A7-\u00AC\u00AE\u00B0-\u00B1\u00B4-\u00B7\u00BA-\u00BB\u00BF-\u00CF\u00D1-\u00FD\u00FF\u0141\u0152-\u0153\u0178\u0192\u03A3\u03A9\u03C0\u2013-\u2014\u2018-\u201A\u201C-\u201E\u2020\u2022\u2026\u2122\u2202\u2206\u220F\u2219-\u221A\u221E\u222B\u2248\u2260\u2264-\u2265\u25CA]/g;
// Ðþ
var RUNIC_CHARACTERS = /[\u00D0\u00FE]/g;

var DetailedCropper = createReactClass({
	selection: null,
	selectionImage: null,
	cropPosition: {'x' : 0, 'y' : 0 },
	lastValidXY: {'x' : 0, 'y' : 0 },
	lastScale: 1.0,
	preScale: 1.0,
	boundaryPoints: {
		'x1' : 0, 'y1': 0,
		'x2' : 0, 'y2' : 0
	},
	customSettings: null,

	getInitialState: function() {
		return {item: this.props.item, options: this.props.item.options,
			imageFile: null,
			aspectRatio: 1.0, selectionSize: {w: 0, h: 0 },
			selectionPosition: {x: 0, y: 15},
			overlaySize: {
				vertical: {width: 15, height: 400},
				horisontal: {width: 400, height: 15}
			},
			imageSize: {w: 0, h: 0},
			labelFontSize: '28px' };
	},

	touchInteractionCallback: function(event, instance) {
		touchHandler.handleTouchInteraction(event, this);
	},

	selectionImageCallback: function(selectionImage) {
		if(document.getElementById('cropper-image')) {
			this.selectionImage = selectionImage;
		}
	},

	componentDidMount: function() {
		var instance, mc, pinch,
			componentNode = ReactDOM.findDOMNode(this);
		// Render the cropper based on the product format and the window size
		instance = this;
		// Setup component
		this.selection = document.getElementById('ope-cropper__selection');
		//Get image file loaded into detailed view
		this.setState({
			lastScale: this.props.item.options.scale,
			preScale: this.props.item.options.scale });

		if(this.props.settings) {
			instance.boundaryPoints = {
				'x1': this.props.settings.boundaries.x1, 'y1' : this.props.settings.boundaries.y1,
				'x2' : this.props.settings.boundaries.x2, 'y2' : this.props.settings.boundaries.y2
			};
		}

		this.setState({
			labelFontSize: this.calculateFontSize() + 'px'
		});
		// Listener for handling resize and polaroid font size
		window.addEventListener('resize', this.handleResize);
	},

	componentDidUpdate: function() {
		var options = this.props.item.options;
		this.selection = document.getElementById('ope-cropper__selection');

		if(this.props.settings) {
			this.boundaryPoints = {
				'x1': this.props.settings.boundaries.x1, 'y1' : this.props.settings.boundaries.y1,
				'x2' : this.props.settings.boundaries.x2, 'y2' : this.props.settings.boundaries.y2
			};
		}

		var customSettings = this.props.item.getCustomSettings();
		// Check if the product has been updated and needs to calculate fontSize for polaroid label
		if(!this.state.customSettings && customSettings) {
			if(customSettings.polaroid || customSettings.hasLabel) {
				var fontSize = this.calculateFontSize();
				// Update state with fontSize, remember to also update customSettings to prevent endless loop
				this.setState({
					labelFontSize: fontSize + 'px',
					customSettings: customSettings
				});
			}
		}
	},

	componentWillUnmount: function() {
		window.removeEventListener('resize', this.handleResize);
	},

	handleResize: function() {
		var customSettings = this.props.item.getCustomSettings();
		if(customSettings) {
			if(customSettings.polaroid || customSettings.hasLabel) {
				var fontSize = this.calculateFontSize();
				this.setState({
					labelFontSize: fontSize + 'px'
				});
			}
		}
	},

	/**
	 * Function for calculating the appropriate font size of a polaroid or label-supported product
	 * This method is called when the window is resized, and upon mounting the component.
	 * The method assumes that there is a font size defined from the product API (in pt), then tries to convert that
	 * size to pixels based on the product width, both in cms and px.
	 * @NOTE that the pt to inch ratio used here is 1pt = 1/72 inch
	 */
	calculateFontSize: function() {
		var customSettings = this.props.item.getCustomSettings();
		if(customSettings) {
				var item = this.props.item,
				productWidth = item.options.productWidth,
				ptInchRatio = 1/72,
				cmInchRatio = 2.54,
				fontPTSize = customSettings.labelFontSize || 15,
				productEl = document.querySelector('.ope-cropper__filler');

			var fontInchSize = fontPTSize * ptInchRatio;
			var fontCmSize = fontInchSize * cmInchRatio;
			var fontWidthRatio = fontCmSize / productWidth;

			return Math.floor(productEl.offsetWidth * fontWidthRatio);
		}
		else {
			return 0;
		}
	},

	_handleLabelChange: function(event) {
		var item = this.state.item,
			val = event.target.value,
			label = document.getElementById('textMeasure');

		// Filter out all the not supported characters.

		val = val.replace( ALLOWED_LATIN_CHARACTERS, '');
		// Runic characters are special (are accepted within extended latin but don't exist for the font remotely)
		val = val.replace( RUNIC_CHARACTERS,'');

		// Truncate the text, if it is bigger, than allowed.
		if((label.offsetWidth + 30) > event.target.offsetWidth) {
			val = val.substr(0, val.length - 1);
		}

		item.options.polaroidText = val;
		this.setState({
			item : item
		});
		EditorActions.setItemLabel(this.state.item, val);
	},

	/**
	 * Converts percentages to pixel points.
	 *
	 * @param {number} percentageX
	 * @param {number} percentageY
	 * @param image
	 *
	 * @returns {{x: number, y: number}}
	 */
	getXYPosition: function(percentageX, percentageY, image) {
		// Calculate percentage.
		var imageHeight = image.offsetHeight;
		var imageWidth = image.offsetWidth;
		var x = (imageWidth * this.preScale) * percentageX;
		var y = (imageHeight * this.preScale) * percentageY;

		return {
			x: x,
			y: y
		};
	},

	/**
	 * Converts pixel points to percentages.
	 *
	 * @param {number} x
	 * @param {number} y
	 * @param image
	 *
	 * @returns {{percentageX: number, percentageY: number}}
	 */
	getXYPercentage: function(x, y, image) {
		// Calculate percentage.
		var imageHeight = image.offsetHeight;
		var imageWidth = image.offsetWidth;
		var percentageX = x / (imageWidth * this.preScale);
		var percentageY = y / (imageHeight * this.preScale);

		// Note: The values between 0 and 1 and not 0 and 100.
		return {
			percentageX: percentageX,
			percentageY: percentageY
		};
	},

	/**
	 * Stores percentages.
	 *
	 * @param {number} scale
	 * @param {number} x
	 * @param {number} y
	 * @param image
	 */
	saveCropPosition: function(scale, x, y, image) {
		// Get percentage.
		var percentage = this.getXYPercentage(x, y, image);

		//Save crop position to the order store
		SelectorActions.setItemCropPositionAndScale(this.props.item, scale, percentage.percentageX, percentage.percentageY);
	},

	_getFillerStyle: function() {

	},

	render: function() {
		var item = this.state.item,
			instance = this;

		if(this.props.settings) {
			var settings = this.props.settings,
				customSettings = item.getCustomSettings();
			var cropperStyle = {
				height: settings.fillerSize.height > 0 ? settings.fillerSize.height + 30 : (settings.selectionSettings.height + 30 )
			};
			var label = <span />;

			if(customSettings) {
				if(customSettings.polaroid) {
					var labelStyle = {width: settings.selectionSettings.width, fontSize: this.state.labelFontSize };
					var canvasStyle = {width: settings.selectionSettings.width, height: 94, fontSize: this.state.labelFontSize };
					label =
						<div>
							<input style={labelStyle} type="text" name="image-label" className="ope-cropper__label ope-cropper__label--polaroid" onChange={this._handleLabelChange}
								value={this.state.item.options.polaroidText} placeholder={_("Click here to add polaroid text") } />
							<span id="textMeasure" style={labelStyle}>{this.state.item.options.polaroidText}</span>
						</div>;
				}
			}
			//console.log(cropperStyle);
			var fillerStyle = {
				'wrapper' : {
					left: settings.selectionSettings.x - ((settings.fillerSize.width - settings.selectionSettings.width) / 2), top: 15,
					width: Math.floor(settings.fillerSize.width),
					height: Math.floor(settings.fillerSize.height)
				},
				'left' : {
					height: '100%',
					width: (settings.fillerSize.width - settings.selectionSettings.width) / 2
				},
				'right' : {
					height: '100%',
					width: (settings.fillerSize.width - settings.selectionSettings.width) / 2
				},
				'top' : {
					height: (settings.fillerSize.width - settings.selectionSettings.width) / 2
				},
				'bottom' : {
					height: (settings.fillerSize.height - settings.selectionSettings.height ) - (settings.fillerSize.width - settings.selectionSettings.width) / 2
				}
			};

			var selectionClass = '';
			return (
				<div className="ope-editor__detailed__cropper" id="ope-cropper" style={cropperStyle} >
					<div className="ope-cropper__overlay ope-cropper__overlay--top" style={this.props.settings.overlaySize.horisontal}></div>
					<div className="ope-cropper__overlay ope-cropper__overlay--left" style={this.props.settings.overlaySize.vertical}></div>
					<div className="ope-cropper__overlay ope-cropper__overlay--right" style={this.props.settings.overlaySize.vertical} ></div>
					<div className="ope-cropper__overlay ope-cropper__overlay--bottom" style={this.props.settings.overlaySize.horisontal}></div>
					<ImageContainer item={item} options={item.options} imageSource={this.props.imageSource}
						elementId="ope-cropper__selection" settings={this.props.settings}
						imageSize={this.props.settings.imageSize} touchInteractionCallback={this.touchInteractionCallback} selectionImageCallback={this.selectionImageCallback}
						imageLoadingCallback={this.props.imageLoadingCallback} >
						<CropperRotate item={item}/>
						<CropperZoom instance={this}/>
					</ImageContainer>
					<div className="ope-cropper__filler" style={fillerStyle.wrapper}>
						<div className="ope-cropper__filler--top" style={fillerStyle.top}></div>
						<div className="ope-cropper__filler--left" style={fillerStyle.left}></div>
						<div className="ope-cropper__filler--right" style={fillerStyle.right}></div>
						<div className="ope-cropper__filler--bottom" style={fillerStyle.bottom}>
							{ label }
						</div>
					</div>
				</div>
			);
		}
		else {
			return (
				<div className="ope-editor__detailed__cropper" id="ope-cropper"></div>
			);
		}
	}
});

export default DetailedCropper;
